import { theme } from '@xsite-ui/common.style';
import { commonBreakpoints } from '@xsite-ui/common.style/breakpoints';
import _defineProperty$1 from '@babel/runtime/helpers/esm/defineProperty';
import { SLOTS_UK_PAGE_IN_GAMBLING_PAGE_ID, PGR_PPC_PAGE_ID, CASINO_SE_SPORT_BETTING_INNER_CHART_PAGE_ID, CASINO_RO_MID_CHART_IN_SPORT_RO_PAGE_ID, SLOTS_UK_MID_CHART_IN_BINGO_PAGE_ID, CASINO_CHART_CROSS_IN_BINGO_PAGE_ID, MID_CHART_CASINO_IN_SPORT_PAGE_ID, CASINO_CHART_CROSS_IN_SPORT_PAGE_ID, CASINO_RO_CROSS_IN_SPORT_RO_PAGE_ID, SPORT_ONLINE_CASINO_PAGE_ID, LIVE_CASINO_CHART_PAGE_IN_CASINO_PAGE_ID, BLACKJACK_CHART_CROSS_IN_CASINO_PAGE_ID, SPORT_AU_PRODUCT_POPUP_PAGE_ID, BINGO_UK_SITE_ID, SPORT_UK_SITE_ID, SPORT_RO_SITE_ID, SPORT_FR_SITE_ID, CASINO_UK_SITE_ID, SLOTS_UK_SITE_ID, ROULETTE_UK_SITE_ID, BLACKJACK_UK_SITE_ID, CASINO_RO_SITE_ID, GAMBLING_UK_SITE_ID, RUMMY_IN_SITE_ID, POKER_UK_SITE_ID, SLOTS_RO_SITE_ID, CASINO_NL_SITE_ID, CASINO_SE_SITE_ID, SPORT_AU_SITE_ID } from '@xsite-ui/gaming.site-and-page-ids';
import { useTheme } from '@emotion/react';
import React from 'react';

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}

var baseDesktopTheme = {
  baseColor1: '#ffffff',
  baseColor2: '#eeeeee',
  baseColor3: '#888888',
  baseColor4: '#000000',
  baseColor5: '#008df7',
  baseColor6: '#124da8',
  baseColor7: '#062a61',
  baseColor8: '#ffd600',
  baseColor9: '#2dcc70',
  baseColor10: '#fd6262'
};

var barbieDesktopTheme = _objectSpread2(_objectSpread2({}, baseDesktopTheme), {}, {
  color1: 'linear-gradient(279.42deg, #dc2da3 0%, #ff44c2 100%)',
  color2: 'linear-gradient(279.42deg, #ff44c2 0%, #fe99dd 100%)',
  color3: '#ca93e1',
  color4: '#2d2d2d',
  color1From: '#dc2da3',
  color2From: '#ff44c2',
  color1To: '#ff44c2',
  color2To: '#fe99dd'
});

var cheltenhamDesktopTheme = _objectSpread2(_objectSpread2({}, baseDesktopTheme), {}, {
  color1: 'linear-gradient(279.42deg, #007f32 0%, #66b284 100%)',
  color2: 'linear-gradient(279.42deg, #5dae7d 0%, #87c6a0 100%)',
  color3: '#cf9f60',
  color4: '#2d2d2d',
  color1From: '#007f32',
  color2From: '#5dae7d',
  color1To: '#66b284',
  color2To: '#87c6a0'
});

var goldDesktopTheme = _objectSpread2(_objectSpread2({}, baseDesktopTheme), {}, {
  color1: 'linear-gradient(132deg, #ffc700 0%, #ff7a00 100%)',
  color2: 'linear-gradient(94deg, #ffd53f 0%, #ff9900 100%)',
  color3: '#f57C00',
  color4: '#2d2d2d',
  color1From: '#ffc700',
  color2From: '#ffd53f',
  color1To: '#ff7a00',
  color2To: '#ff9900'
});

var grassDesktopTheme = _objectSpread2(_objectSpread2({}, baseDesktopTheme), {}, {
  color1: 'linear-gradient(135deg, #00e031 0%, #00600f 100%)',
  color2: 'linear-gradient(135deg, #2dff5b 0%, #009317 100%)',
  color3: '#50b401',
  color4: '#1b3fa0',
  color1From: '#00e031',
  color2From: '#2dff5b',
  color1To: '#00600f',
  color2To: '#009317'
});

var hotDesktopTheme = _objectSpread2(_objectSpread2({}, baseDesktopTheme), {}, {
  color1: 'linear-gradient(135deg, #ff3f3f 0%, #bb0022 100%)',
  color2: 'linear-gradient(135deg, #ff7e7e 0%, #f40808 100%)',
  color3: '#fb0608',
  color4: '#2d2d2d',
  color1From: '#ff3f3f',
  color2From: '#ff7e7e',
  color1To: '#bb0022',
  color2To: '#f40808'
});

var oceanDesktopTheme = _objectSpread2(_objectSpread2({}, baseDesktopTheme), {}, {
  color1: 'linear-gradient(135deg, #2cb3ff 0%, #0054d0 100%)',
  color2: 'linear-gradient(135deg, #2db3ff 0%, #076bff 100%)',
  color3: '#0063fc',
  color4: '#1b3fa0',
  color1From: '#2cb3ff',
  color2From: '#2db3ff',
  color1To: '#0054d0',
  color2To: '#076bff'
});

var index$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  barbieDesktopTheme: barbieDesktopTheme,
  cheltenhamDesktopTheme: cheltenhamDesktopTheme,
  goldDesktopTheme: goldDesktopTheme,
  grassDesktopTheme: grassDesktopTheme,
  hotDesktopTheme: hotDesktopTheme,
  oceanDesktopTheme: oceanDesktopTheme
});

var baseMobileDarkTheme = {
  baseColor1: '#ffffff',
  baseColor2: '#ffffff',
  baseColor3: '#eeeeee',
  baseColor4: '#a5a5a5',
  baseColor5: '#252525',
  baseColor6: '#424242',
  baseColor7: '#000000',
  baseColor8: '#1a9cff',
  baseColor9: '#ffd600',
  baseColor10: '#2dcc70',
  baseColor11: '#fd6262',
  baseColor12: '#124da8',
  baseColor13: '#000000',
  isDark: true
};

var barbieDarkMobileTheme = _objectSpread2(_objectSpread2({}, baseMobileDarkTheme), {}, {
  color1: 'linear-gradient(135deg, #dc2da3 0%, #dc2da3 100%)',
  color2: 'linear-gradient(135deg, #ff44c2 0%, #ff44c2 100%)',
  color3: '#ca93e1',
  color4: '#532591',
  color5: '#d70074',
  color1From: '#dc2da3',
  color1To: '#dc2da3',
  color2From: '#ff44c2',
  color2To: '#ff44c2'
});

var baseMobileLightTheme = {
  baseColor1: '#ffffff',
  baseColor2: '#000000',
  baseColor3: '#eeeeee',
  baseColor4: '#666666',
  baseColor5: '#eeeeee',
  baseColor6: '#ffffff',
  baseColor7: '#bbbbbb',
  baseColor8: '#0083e7',
  baseColor9: '#ffb802',
  baseColor10: '#2dcc70',
  baseColor11: '#fd6262',
  baseColor12: '#002683',
  baseColor13: '#000000',
  isDark: false
};

var barbieLightMobileTheme = _objectSpread2(_objectSpread2({}, baseMobileLightTheme), {}, {
  color1: 'linear-gradient(135deg, #dc2da3 0%, #dc2da3 100%)',
  color2: 'linear-gradient(135deg, #ff44c2 0%, #ff44c2 100%)',
  color3: '#ca93e1',
  color4: '#532591',
  color5: '#d70074',
  color1From: '#dc2da3',
  color1To: '#dc2da3',
  color2From: '#ff44c2',
  color2To: '#ff44c2'
});

var cheltenhamDarkMobileTheme = _objectSpread2(_objectSpread2({}, baseMobileDarkTheme), {}, {
  color1: 'linear-gradient(99.42deg, #66b284 0%, #007f32 100%)',
  color2: 'linear-gradient(99.42deg, #87c6a0 0%, #5eaf7e 100%)',
  color3: '#cf9f60',
  color4: '#007f32',
  color5: '#cf9f60',
  color1From: '#66b284',
  color1To: '#007f32',
  color2From: '#87c6a0',
  color2To: '#5eaf7e'
});

var cheltenhamLightMobileTheme = _objectSpread2(_objectSpread2({}, baseMobileLightTheme), {}, {
  color1: 'linear-gradient(99.42deg, #66b284 0%, #007f32 100%)',
  color2: 'linear-gradient(99.42deg, #87c6a0 0%, #5eaf7e 100%)',
  color3: '#cf9f60',
  color4: '#007f32',
  color5: '#cf9f60',
  color1From: '#66b284',
  color1To: '#007f32',
  color2From: '#87c6a0',
  color2To: '#5eaf7e'
});

var goldDarkMobileTheme = _objectSpread2(_objectSpread2({}, baseMobileDarkTheme), {}, {
  color1: 'linear-gradient(132deg, #ffc700 0%, #ff7a00 100%)',
  color2: 'linear-gradient(94deg, #ffd53f 0%, #ff9900 100%)',
  color3: '#ff8c05',
  color4: '#ffb905',
  color5: '#ffd600',
  color1From: '#ffc700',
  color1To: '#ff7a00',
  color2From: '#ffd53f',
  color2To: '#ff9900'
});

var goldLightMobileTheme = _objectSpread2(_objectSpread2({}, baseMobileLightTheme), {}, {
  color1: 'linear-gradient(132deg, #ffc700 0%, #ff7a00 100%)',
  color2: 'linear-gradient(94deg, #ffd53f 0%, #ff9900 100%)',
  color3: '#ff8c05',
  color4: '#ffb905',
  color5: '#ffd600',
  color1From: '#ffc700',
  color1To: '#ff7a00',
  color2From: '#ffd53f',
  color2To: '#ff9900'
});

var grassDarkMobileTheme = _objectSpread2(_objectSpread2({}, baseMobileDarkTheme), {}, {
  color1: 'linear-gradient(135deg, #00e031 0%, #00600f 100%)',
  color2: 'linear-gradient(135deg, #2dff5b 0%, #009317 100%)',
  color3: '#018519',
  color4: '#0eaf00',
  color5: '#0063fc',
  color1From: '#00e031',
  color1To: '#00600f',
  color2From: '#2dff5b',
  color2To: '#009317'
});

var grassLightMobileTheme = _objectSpread2(_objectSpread2({}, baseMobileLightTheme), {}, {
  color1: 'linear-gradient(135deg, #00e031 0%, #00600f 100%)',
  color2: 'linear-gradient(135deg, #2dff5b 0%, #009317 100%)',
  color3: '#018519',
  color4: '#0eaf00',
  color5: '#0063fc',
  color1From: '#00e031',
  color1To: '#00600f',
  color2From: '#2dff5b',
  color2To: '#009317'
});

var hotDarkMobileTheme = _objectSpread2(_objectSpread2({}, baseMobileDarkTheme), {}, {
  color1: 'linear-gradient(135deg, #ff3f3f 0%, #bb0022 100%)',
  color2: 'linear-gradient(135deg, #ff7e7e 0%, #f40808 100%)',
  color3: '#fb0608',
  color4: '#ffb905',
  color5: '#ffd600',
  color1From: '#ff3f3f',
  color1To: '#bb0022',
  color2From: '#ff7e7e',
  color2To: '#f40808'
});

var hotLightMobileTheme = _objectSpread2(_objectSpread2({}, baseMobileLightTheme), {}, {
  color1: 'linear-gradient(135deg, #ff3f3f 0%, #bb0022 100%)',
  color2: 'linear-gradient(135deg, #ff7e7e 0%, #f40808 100%)',
  color3: '#fb0608',
  color4: '#ffb905',
  color5: '#ffd600',
  color1From: '#ff3f3f',
  color1To: '#bb0022',
  color2From: '#ff7e7e',
  color2To: '#f40808'
});

var oceanDarkMobileTheme = _objectSpread2(_objectSpread2({}, baseMobileDarkTheme), {}, {
  color1: 'linear-gradient(135deg, #2cb3ff 0%, #0054d0 100%)',
  color2: 'linear-gradient(135deg, #2db3ff 0%, #076bff 100%)',
  color3: '#0d47a1',
  color4: '#0063fc',
  color5: '#0eaf00',
  color1From: '#2db3ff',
  color1To: '#0054d0',
  color2From: '#2db3ff',
  color2To: '#076bff'
});

var oceanLightMobileTheme = _objectSpread2(_objectSpread2({}, baseMobileLightTheme), {}, {
  color1: 'linear-gradient(135deg, #2cb3ff 0%, #0054d0 100%)',
  color2: 'linear-gradient(135deg, #2db3ff 0%, #076bff 100%)',
  color3: '#0d47a1',
  color4: '#0063fc',
  color5: '#0eaf00',
  color1From: '#2db3ff',
  color1To: '#0054d0',
  color2From: '#2db3ff',
  color2To: '#076bff'
});

var skyDarkMobileTheme = _objectSpread2(_objectSpread2({}, baseMobileDarkTheme), {}, {
  color1: 'linear-gradient(132deg, #6094ea 0%, #f030C1 100%)',
  color2: 'linear-gradient(132deg, #6ba2ff 0%, #ff4ad3 100%)',
  color3: '#00c9f5',
  color4: '#17ead9',
  color5: '#ffd600',
  color1From: '#6094ea',
  color1To: '#f030C1',
  color2From: '#6ba2ff',
  color2To: '#ff4ad3'
});

var skyLightMobileTheme = _objectSpread2(_objectSpread2({}, baseMobileLightTheme), {}, {
  color1: 'linear-gradient(132deg, #6094ea 0%, #f030C1 100%)',
  color2: 'linear-gradient(132deg, #6ba2ff 0%, #ff4ad3 100%)',
  color3: '#00c9f5',
  color4: '#17ead9',
  color5: '#ffd600',
  color1From: '#6094ea',
  color1To: '#f030C1',
  color2From: '#6ba2ff',
  color2To: '#ff4ad3'
});

var index = /*#__PURE__*/Object.freeze({
  __proto__: null,
  barbieDarkMobileTheme: barbieDarkMobileTheme,
  barbieLightMobileTheme: barbieLightMobileTheme,
  cheltenhamDarkMobileTheme: cheltenhamDarkMobileTheme,
  cheltenhamLightMobileTheme: cheltenhamLightMobileTheme,
  goldDarkMobileTheme: goldDarkMobileTheme,
  goldLightMobileTheme: goldLightMobileTheme,
  grassDarkMobileTheme: grassDarkMobileTheme,
  grassLightMobileTheme: grassLightMobileTheme,
  hotDarkMobileTheme: hotDarkMobileTheme,
  hotLightMobileTheme: hotLightMobileTheme,
  oceanDarkMobileTheme: oceanDarkMobileTheme,
  oceanLightMobileTheme: oceanLightMobileTheme,
  skyDarkMobileTheme: skyDarkMobileTheme,
  skyLightMobileTheme: skyLightMobileTheme
});

function addVariants(theme) {
  var _theme$mobile$color, _theme$mobile, _theme$mobile$baseCol, _theme$mobile2, _theme$mobile$baseCol2, _theme$mobile3, _theme$mobile$baseCol3, _theme$mobile4, _theme$mobile$baseCol4, _theme$mobile5, _theme$mobile$baseCol5, _theme$mobile6, _theme$mobile$baseCol6, _theme$mobile7, _theme$mobile$baseCol7, _theme$mobile8, _theme$mobile$baseCol8, _theme$mobile9, _theme$mobile$baseCol9, _theme$mobile10, _theme$mobile$baseCol10, _theme$mobile11, _theme$mobile$baseCol11, _theme$mobile12, _theme$mobile$baseCol12, _theme$mobile13, _theme$mobile$baseCol13, _theme$mobile14, _theme$mobile$baseCol14, _theme$mobile15, _theme$mobile$color2, _theme$mobile16, _theme$mobile$baseCol15, _theme$mobile17, _theme$mobile$baseCol16, _theme$mobile18, _theme$mobile$baseCol17, _theme$mobile19, _theme$mobile$baseCol18, _theme$mobile20, _theme$mobile$baseCol19, _theme$mobile21, _theme$mobile$color3, _theme$mobile22, _theme$mobile$baseCol20, _theme$mobile23, _theme$mobile$baseCol21, _theme$mobile24, _theme$mobile$baseCol22, _theme$mobile25, _theme$desktop$baseCo, _theme$desktop, _theme$desktop$baseCo2, _theme$desktop2, _theme$desktop$baseCo3, _theme$desktop3, _theme$desktop$baseCo4, _theme$desktop4, _theme$desktop$baseCo5, _theme$desktop5, _theme$desktop$baseCo6, _theme$desktop6, _theme$desktop$baseCo7, _theme$desktop7, _theme$desktop$baseCo8, _theme$desktop8, _theme$desktop$baseCo9, _theme$desktop9, _theme$desktop$baseCo10, _theme$desktop10, _theme$desktop$baseCo11, _theme$desktop11, _theme$desktop$baseCo12, _theme$desktop12, _theme$desktop$baseCo13, _theme$desktop13, _theme$desktop$baseCo14, _theme$desktop14, _theme$desktop$baseCo15, _theme$desktop15, _theme$desktop$baseCo16, _theme$desktop16, _theme$desktop$color, _theme$desktop17, _theme$desktop$baseCo17, _theme$desktop18, _theme$desktop$baseCo18, _theme$desktop19, _theme$desktop$baseCo19, _theme$desktop20, _theme$desktop$baseCo20, _theme$desktop21, _theme$desktop$baseCo21, _theme$desktop22, _theme$desktop$color2, _theme$desktop23, _theme$desktop$baseCo22, _theme$desktop24, _theme$desktop$color3, _theme$desktop25, _theme$desktop$baseCo23, _theme$desktop26, _theme$desktop$baseCo24, _theme$desktop27, _theme$desktop$baseCo25, _theme$desktop28, _theme$mobile$baseCol23, _theme$mobile26, _theme$mobile$color4, _theme$mobile27, _theme$fonts$body, _theme$fonts, _theme$fontWeights$me, _theme$fontWeights, _theme$mobile$color5, _theme$mobile28;

  var variants = _objectSpread2(_objectSpread2({}, theme.variants), {}, {
    partnerCard: {
      backgroundColor: (_theme$mobile$color = (_theme$mobile = theme.mobile) === null || _theme$mobile === void 0 ? void 0 : _theme$mobile.color2) !== null && _theme$mobile$color !== void 0 ? _theme$mobile$color : '',
      highlightsBGColor: (_theme$mobile$baseCol = (_theme$mobile2 = theme.mobile) === null || _theme$mobile2 === void 0 ? void 0 : _theme$mobile2.baseColor6) !== null && _theme$mobile$baseCol !== void 0 ? _theme$mobile$baseCol : '',
      expertReview: {
        backgroundColor: (_theme$mobile$baseCol2 = (_theme$mobile3 = theme.mobile) === null || _theme$mobile3 === void 0 ? void 0 : _theme$mobile3.baseColor5) !== null && _theme$mobile$baseCol2 !== void 0 ? _theme$mobile$baseCol2 : '',
        fontColor: (_theme$mobile$baseCol3 = (_theme$mobile4 = theme.mobile) === null || _theme$mobile4 === void 0 ? void 0 : _theme$mobile4.baseColor2) !== null && _theme$mobile$baseCol3 !== void 0 ? _theme$mobile$baseCol3 : '',
        reviewLinkFontColor: (_theme$mobile$baseCol4 = (_theme$mobile5 = theme.mobile) === null || _theme$mobile5 === void 0 ? void 0 : _theme$mobile5.baseColor8) !== null && _theme$mobile$baseCol4 !== void 0 ? _theme$mobile$baseCol4 : ''
      },
      bonusCtaTerms: {
        backgroundColor: (_theme$mobile$baseCol5 = (_theme$mobile6 = theme.mobile) === null || _theme$mobile6 === void 0 ? void 0 : _theme$mobile6.baseColor6) !== null && _theme$mobile$baseCol5 !== void 0 ? _theme$mobile$baseCol5 : '',
        bonusFontColor: (_theme$mobile$baseCol6 = (_theme$mobile7 = theme.mobile) === null || _theme$mobile7 === void 0 ? void 0 : _theme$mobile7.baseColor2) !== null && _theme$mobile$baseCol6 !== void 0 ? _theme$mobile$baseCol6 : '',
        termsFontColor: (_theme$mobile$baseCol7 = (_theme$mobile8 = theme.mobile) === null || _theme$mobile8 === void 0 ? void 0 : _theme$mobile8.baseColor4) !== null && _theme$mobile$baseCol7 !== void 0 ? _theme$mobile$baseCol7 : ''
      },
      logoAndScore: {
        partnerHeaderBGColor: (_theme$mobile$baseCol8 = (_theme$mobile9 = theme.mobile) === null || _theme$mobile9 === void 0 ? void 0 : _theme$mobile9.baseColor6) !== null && _theme$mobile$baseCol8 !== void 0 ? _theme$mobile$baseCol8 : '',
        productNameColor: (_theme$mobile$baseCol9 = (_theme$mobile10 = theme.mobile) === null || _theme$mobile10 === void 0 ? void 0 : _theme$mobile10.baseColor2) !== null && _theme$mobile$baseCol9 !== void 0 ? _theme$mobile$baseCol9 : '',
        visitLinkColor: (_theme$mobile$baseCol10 = (_theme$mobile11 = theme.mobile) === null || _theme$mobile11 === void 0 ? void 0 : _theme$mobile11.baseColor8) !== null && _theme$mobile$baseCol10 !== void 0 ? _theme$mobile$baseCol10 : '',
        scoreColor: (_theme$mobile$baseCol11 = (_theme$mobile12 = theme.mobile) === null || _theme$mobile12 === void 0 ? void 0 : _theme$mobile12.baseColor1) !== null && _theme$mobile$baseCol11 !== void 0 ? _theme$mobile$baseCol11 : '',
        scoreTextColor: (_theme$mobile$baseCol12 = (_theme$mobile13 = theme.mobile) === null || _theme$mobile13 === void 0 ? void 0 : _theme$mobile13.baseColor1) !== null && _theme$mobile$baseCol12 !== void 0 ? _theme$mobile$baseCol12 : ''
      },
      carousel: {
        gradientColors: [(_theme$mobile$baseCol13 = (_theme$mobile14 = theme.mobile) === null || _theme$mobile14 === void 0 ? void 0 : _theme$mobile14.baseColor6) !== null && _theme$mobile$baseCol13 !== void 0 ? _theme$mobile$baseCol13 : '', (_theme$mobile$baseCol14 = (_theme$mobile15 = theme.mobile) === null || _theme$mobile15 === void 0 ? void 0 : _theme$mobile15.baseColor6) !== null && _theme$mobile$baseCol14 !== void 0 ? _theme$mobile$baseCol14 : '', (_theme$mobile$color2 = (_theme$mobile16 = theme.mobile) === null || _theme$mobile16 === void 0 ? void 0 : _theme$mobile16.color1) !== null && _theme$mobile$color2 !== void 0 ? _theme$mobile$color2 : ''],
        titleColor: (_theme$mobile$baseCol15 = (_theme$mobile17 = theme.mobile) === null || _theme$mobile17 === void 0 ? void 0 : _theme$mobile17.baseColor2) !== null && _theme$mobile$baseCol15 !== void 0 ? _theme$mobile$baseCol15 : '',
        gameCountTitleColor: (_theme$mobile$baseCol16 = (_theme$mobile18 = theme.mobile) === null || _theme$mobile18 === void 0 ? void 0 : _theme$mobile18.baseColor2) !== null && _theme$mobile$baseCol16 !== void 0 ? _theme$mobile$baseCol16 : '',
        gameCountTextColor: (_theme$mobile$baseCol17 = (_theme$mobile19 = theme.mobile) === null || _theme$mobile19 === void 0 ? void 0 : _theme$mobile19.baseColor2) !== null && _theme$mobile$baseCol17 !== void 0 ? _theme$mobile$baseCol17 : ''
      },
      productReviewPreview: {
        backgroundColor: (_theme$mobile$baseCol18 = (_theme$mobile20 = theme.mobile) === null || _theme$mobile20 === void 0 ? void 0 : _theme$mobile20.baseColor6) !== null && _theme$mobile$baseCol18 !== void 0 ? _theme$mobile$baseCol18 : '',
        titleColor: (_theme$mobile$baseCol19 = (_theme$mobile21 = theme.mobile) === null || _theme$mobile21 === void 0 ? void 0 : _theme$mobile21.baseColor2) !== null && _theme$mobile$baseCol19 !== void 0 ? _theme$mobile$baseCol19 : '',
        imageBGColor: (_theme$mobile$color3 = (_theme$mobile22 = theme.mobile) === null || _theme$mobile22 === void 0 ? void 0 : _theme$mobile22.color2) !== null && _theme$mobile$color3 !== void 0 ? _theme$mobile$color3 : ''
      },
      trophy: {
        fontColor: (_theme$mobile$baseCol20 = (_theme$mobile23 = theme.mobile) === null || _theme$mobile23 === void 0 ? void 0 : _theme$mobile23.baseColor2) !== null && _theme$mobile$baseCol20 !== void 0 ? _theme$mobile$baseCol20 : ''
      },
      tagline: {
        mainColor: (_theme$mobile$baseCol21 = (_theme$mobile24 = theme.mobile) === null || _theme$mobile24 === void 0 ? void 0 : _theme$mobile24.baseColor2) !== null && _theme$mobile$baseCol21 !== void 0 ? _theme$mobile$baseCol21 : '',
        fontColor: (_theme$mobile$baseCol22 = (_theme$mobile25 = theme.mobile) === null || _theme$mobile25 === void 0 ? void 0 : _theme$mobile25.baseColor2) !== null && _theme$mobile$baseCol22 !== void 0 ? _theme$mobile$baseCol22 : ''
      }
    },
    miniReviews: {
      header: {
        backgroundColor: (_theme$desktop$baseCo = (_theme$desktop = theme.desktop) === null || _theme$desktop === void 0 ? void 0 : _theme$desktop.baseColor5) !== null && _theme$desktop$baseCo !== void 0 ? _theme$desktop$baseCo : '',
        color: (_theme$desktop$baseCo2 = (_theme$desktop2 = theme.desktop) === null || _theme$desktop2 === void 0 ? void 0 : _theme$desktop2.baseColor1) !== null && _theme$desktop$baseCo2 !== void 0 ? _theme$desktop$baseCo2 : ''
      },
      scoreAndRating: {
        scoreColor: (_theme$desktop$baseCo3 = (_theme$desktop3 = theme.desktop) === null || _theme$desktop3 === void 0 ? void 0 : _theme$desktop3.baseColor5) !== null && _theme$desktop$baseCo3 !== void 0 ? _theme$desktop$baseCo3 : '',
        scoreLabelColor: (_theme$desktop$baseCo4 = (_theme$desktop4 = theme.desktop) === null || _theme$desktop4 === void 0 ? void 0 : _theme$desktop4.baseColor4) !== null && _theme$desktop$baseCo4 !== void 0 ? _theme$desktop$baseCo4 : '',
        borderTop: (_theme$desktop$baseCo5 = (_theme$desktop5 = theme.desktop) === null || _theme$desktop5 === void 0 ? void 0 : _theme$desktop5.baseColor5) !== null && _theme$desktop$baseCo5 !== void 0 ? _theme$desktop$baseCo5 : '',
        ratingColor: (_theme$desktop$baseCo6 = (_theme$desktop6 = theme.desktop) === null || _theme$desktop6 === void 0 ? void 0 : _theme$desktop6.baseColor8) !== null && _theme$desktop$baseCo6 !== void 0 ? _theme$desktop$baseCo6 : ''
      },
      topHighlights: {
        borderTop: (_theme$desktop$baseCo7 = (_theme$desktop7 = theme.desktop) === null || _theme$desktop7 === void 0 ? void 0 : _theme$desktop7.baseColor5) !== null && _theme$desktop$baseCo7 !== void 0 ? _theme$desktop$baseCo7 : '',
        color: (_theme$desktop$baseCo8 = (_theme$desktop8 = theme.desktop) === null || _theme$desktop8 === void 0 ? void 0 : _theme$desktop8.baseColor4) !== null && _theme$desktop$baseCo8 !== void 0 ? _theme$desktop$baseCo8 : ''
      },
      welcomeBonus: {
        borderTop: (_theme$desktop$baseCo9 = (_theme$desktop9 = theme.desktop) === null || _theme$desktop9 === void 0 ? void 0 : _theme$desktop9.baseColor5) !== null && _theme$desktop$baseCo9 !== void 0 ? _theme$desktop$baseCo9 : '',
        color: (_theme$desktop$baseCo10 = (_theme$desktop10 = theme.desktop) === null || _theme$desktop10 === void 0 ? void 0 : _theme$desktop10.baseColor4) !== null && _theme$desktop$baseCo10 !== void 0 ? _theme$desktop$baseCo10 : '',
        ctaColor: (_theme$desktop$baseCo11 = (_theme$desktop11 = theme.desktop) === null || _theme$desktop11 === void 0 ? void 0 : _theme$desktop11.baseColor5) !== null && _theme$desktop$baseCo11 !== void 0 ? _theme$desktop$baseCo11 : ''
      },
      productReviewBrief: {
        borderTop: (_theme$desktop$baseCo12 = (_theme$desktop12 = theme.desktop) === null || _theme$desktop12 === void 0 ? void 0 : _theme$desktop12.baseColor5) !== null && _theme$desktop$baseCo12 !== void 0 ? _theme$desktop$baseCo12 : '',
        title: (_theme$desktop$baseCo13 = (_theme$desktop13 = theme.desktop) === null || _theme$desktop13 === void 0 ? void 0 : _theme$desktop13.baseColor4) !== null && _theme$desktop$baseCo13 !== void 0 ? _theme$desktop$baseCo13 : '',
        authorName: (_theme$desktop$baseCo14 = (_theme$desktop14 = theme.desktop) === null || _theme$desktop14 === void 0 ? void 0 : _theme$desktop14.baseColor5) !== null && _theme$desktop$baseCo14 !== void 0 ? _theme$desktop$baseCo14 : '',
        quotes: (_theme$desktop$baseCo15 = (_theme$desktop15 = theme.desktop) === null || _theme$desktop15 === void 0 ? void 0 : _theme$desktop15.baseColor4) !== null && _theme$desktop$baseCo15 !== void 0 ? _theme$desktop$baseCo15 : ''
      },
      lightbulb: {
        fill: (_theme$desktop$baseCo16 = (_theme$desktop16 = theme.desktop) === null || _theme$desktop16 === void 0 ? void 0 : _theme$desktop16.baseColor5) !== null && _theme$desktop$baseCo16 !== void 0 ? _theme$desktop$baseCo16 : ''
      },
      footer: {
        ctaBackgroundColor: (_theme$desktop$color = (_theme$desktop17 = theme.desktop) === null || _theme$desktop17 === void 0 ? void 0 : _theme$desktop17.color1) !== null && _theme$desktop$color !== void 0 ? _theme$desktop$color : '',
        ctaColor: (_theme$desktop$baseCo17 = (_theme$desktop18 = theme.desktop) === null || _theme$desktop18 === void 0 ? void 0 : _theme$desktop18.baseColor1) !== null && _theme$desktop$baseCo17 !== void 0 ? _theme$desktop$baseCo17 : '',
        backgroundColor: (_theme$desktop$baseCo18 = (_theme$desktop19 = theme.desktop) === null || _theme$desktop19 === void 0 ? void 0 : _theme$desktop19.baseColor1) !== null && _theme$desktop$baseCo18 !== void 0 ? _theme$desktop$baseCo18 : ''
      },
      body: {
        backgroundColor: (_theme$desktop$baseCo19 = (_theme$desktop20 = theme.desktop) === null || _theme$desktop20 === void 0 ? void 0 : _theme$desktop20.baseColor1) !== null && _theme$desktop$baseCo19 !== void 0 ? _theme$desktop$baseCo19 : ''
      }
    },
    liveFeed: {
      color: (_theme$desktop$baseCo20 = (_theme$desktop21 = theme.desktop) === null || _theme$desktop21 === void 0 ? void 0 : _theme$desktop21.baseColor3) !== null && _theme$desktop$baseCo20 !== void 0 ? _theme$desktop$baseCo20 : '',
      backgroundColor: (_theme$desktop$baseCo21 = (_theme$desktop22 = theme.desktop) === null || _theme$desktop22 === void 0 ? void 0 : _theme$desktop22.baseColor2) !== null && _theme$desktop$baseCo21 !== void 0 ? _theme$desktop$baseCo21 : '',
      titleBackground: (_theme$desktop$color2 = (_theme$desktop23 = theme.desktop) === null || _theme$desktop23 === void 0 ? void 0 : _theme$desktop23.color3) !== null && _theme$desktop$color2 !== void 0 ? _theme$desktop$color2 : '',
      boxShadow: (_theme$desktop$baseCo22 = (_theme$desktop24 = theme.desktop) === null || _theme$desktop24 === void 0 ? void 0 : _theme$desktop24.baseColor4) !== null && _theme$desktop$baseCo22 !== void 0 ? _theme$desktop$baseCo22 : '',
      borderRightColor: (_theme$desktop$color3 = (_theme$desktop25 = theme.desktop) === null || _theme$desktop25 === void 0 ? void 0 : _theme$desktop25.color3) !== null && _theme$desktop$color3 !== void 0 ? _theme$desktop$color3 : '',
      pathFill: (_theme$desktop$baseCo23 = (_theme$desktop26 = theme.desktop) === null || _theme$desktop26 === void 0 ? void 0 : _theme$desktop26.baseColor1) !== null && _theme$desktop$baseCo23 !== void 0 ? _theme$desktop$baseCo23 : '',
      titleColor: (_theme$desktop$baseCo24 = (_theme$desktop27 = theme.desktop) === null || _theme$desktop27 === void 0 ? void 0 : _theme$desktop27.baseColor1) !== null && _theme$desktop$baseCo24 !== void 0 ? _theme$desktop$baseCo24 : '',
      titleWidth: '101px',
      fontSize: '0.75em',
      fontWeight: 500,
      feedLeftPosition: '107px',
      eventBox: {
        fontWeight: 600,
        fontSize: '0.75em',
        color: (_theme$desktop$baseCo25 = (_theme$desktop28 = theme.desktop) === null || _theme$desktop28 === void 0 ? void 0 : _theme$desktop28.baseColor3) !== null && _theme$desktop$baseCo25 !== void 0 ? _theme$desktop$baseCo25 : ''
      },
      eventTitle: {
        fontSize: '0.75em'
      }
    },
    socialResponsibility: {
      gradiantStart: '#6094ea',
      gradiantStop: '#f030c1',
      color1: '#6b8de7',
      color2: '#ac60d5'
    },
    productVideo: {
      backgroundColor: (_theme$mobile$baseCol23 = (_theme$mobile26 = theme.mobile) === null || _theme$mobile26 === void 0 ? void 0 : _theme$mobile26.baseColor5) !== null && _theme$mobile$baseCol23 !== void 0 ? _theme$mobile$baseCol23 : '',
      ctaTextColor: (_theme$mobile$color4 = (_theme$mobile27 = theme.mobile) === null || _theme$mobile27 === void 0 ? void 0 : _theme$mobile27.color3) !== null && _theme$mobile$color4 !== void 0 ? _theme$mobile$color4 : '',
      stripFontSize: '0.75rem',
      stripFont: (_theme$fonts$body = (_theme$fonts = theme.fonts) === null || _theme$fonts === void 0 ? void 0 : _theme$fonts.body) !== null && _theme$fonts$body !== void 0 ? _theme$fonts$body : 'Roboto',
      stripFontWeight: (_theme$fontWeights$me = (_theme$fontWeights = theme.fontWeights) === null || _theme$fontWeights === void 0 ? void 0 : _theme$fontWeights.medium) !== null && _theme$fontWeights$me !== void 0 ? _theme$fontWeights$me : 500,
      playIcon: (_theme$mobile$color5 = (_theme$mobile28 = theme.mobile) === null || _theme$mobile28 === void 0 ? void 0 : _theme$mobile28.color3) !== null && _theme$mobile$color5 !== void 0 ? _theme$mobile$color5 : ''
    }
  });

  return _objectSpread2(_objectSpread2({}, theme), {}, {
    variants: variants
  });
}

var breakpoints = ['360px', '480px', '768px', '1000px', '1024px', '1222px']; // aliases

breakpoints.xs = breakpoints[0];
breakpoints.sm = breakpoints[1];
breakpoints.md = breakpoints[2];
breakpoints.lg = breakpoints[3];
breakpoints.xl = breakpoints[4];
breakpoints.xxl = breakpoints[5];
breakpoints.mobile = commonBreakpoints[0];
breakpoints.tablet = commonBreakpoints[1];
breakpoints.laptop = commonBreakpoints[2];
breakpoints.desktop = commonBreakpoints[3];

var fontWeights = _objectSpread2({}, [400, 500, 700]);

fontWeights.body = fontWeights[0];
fontWeights.medium = fontWeights[1];
fontWeights.bold = fontWeights[2];

var defaultGamingTheme = addVariants(_objectSpread2(_objectSpread2({}, theme), {}, {
  mixins: undefined,
  breakpoints: breakpoints,
  fonts: _objectSpread2(_objectSpread2({}, theme.fonts), {}, {
    body: 'Roboto, Helvetica, Arial, sans-serif'
  }),
  fontSizes: _objectSpread2(_objectSpread2({}, theme.fontSizes), {}, {
    body: 16
  }),
  fontWeights: fontWeights,
  variants: _objectSpread2(_objectSpread2({}, theme.variants), {}, {
    ratingStars: {
      fill: baseDesktopTheme.baseColor8,
      background: '#d5d5d5'
    }
  }),
  name: 'Gaming - Default Theme'
}));

var generalBarbieLightModeBarbie$1 = addVariants(_objectSpread2(_objectSpread2({}, defaultGamingTheme), {}, {
  mobile: barbieLightMobileTheme,
  desktop: barbieDesktopTheme,
  name: 'Gaming - Barbie-LightMode-Barbie'
}));

var generalCheltLightModeChelt = addVariants(_objectSpread2(_objectSpread2({}, defaultGamingTheme), {}, {
  mobile: cheltenhamLightMobileTheme,
  desktop: cheltenhamDesktopTheme,
  name: 'Gaming - Chelt-LightMode-Chelt'
}));

var generalGoldDarkModeGold$1 = addVariants(_objectSpread2(_objectSpread2({}, defaultGamingTheme), {}, {
  mobile: goldDarkMobileTheme,
  desktop: goldDesktopTheme,
  name: 'Gaming - Gold-DarkMode-Gold'
}));

var generalGoldLightModeSky$1 = addVariants(_objectSpread2(_objectSpread2({}, defaultGamingTheme), {}, {
  mobile: skyDarkMobileTheme,
  desktop: goldDesktopTheme,
  name: 'Gaming - Gold-DarkMode-Sky'
}));

var generalGoldLightModeBarbie = addVariants(_objectSpread2(_objectSpread2({}, defaultGamingTheme), {}, {
  mobile: barbieLightMobileTheme,
  desktop: goldDesktopTheme,
  name: 'Gaming - Gold-LightMode-Barbie'
}));

var generalGoldLightModeGold$1 = addVariants(_objectSpread2(_objectSpread2({}, defaultGamingTheme), {}, {
  mobile: goldLightMobileTheme,
  desktop: goldDesktopTheme,
  name: 'Gaming - Gold-LightMode-Gold'
}));

var generalGrassDarkModeGrass = addVariants(_objectSpread2(_objectSpread2({}, defaultGamingTheme), {}, {
  mobile: grassDarkMobileTheme,
  desktop: grassDesktopTheme,
  name: 'Gaming - Grass-DarkMode-Grass'
}));

var generalGrassLightModeGrass$1 = addVariants(_objectSpread2(_objectSpread2({}, defaultGamingTheme), {}, {
  mobile: grassLightMobileTheme,
  desktop: grassDesktopTheme,
  name: 'Gaming - Grass-LightMode-Grass'
}));

var generalHotDarkModeHot$1 = addVariants(_objectSpread2(_objectSpread2({}, defaultGamingTheme), {}, {
  mobile: hotDarkMobileTheme,
  desktop: hotDesktopTheme,
  name: 'Gaming - Hot-DarkMode-Hot'
}));

var generalOceanLightModeOcean$1 = addVariants(_objectSpread2(_objectSpread2({}, defaultGamingTheme), {}, {
  mobile: oceanLightMobileTheme,
  desktop: oceanDesktopTheme,
  name: 'Gaming - Ocean-LightMode-Ocean'
}));

var namedThemes = /*#__PURE__*/Object.freeze({
  __proto__: null,
  generalBarbieLightModeBarbie: generalBarbieLightModeBarbie$1,
  generalCheltLightModeChelt: generalCheltLightModeChelt,
  generalGoldDarkModeGold: generalGoldDarkModeGold$1,
  generalGoldLightModeSky: generalGoldLightModeSky$1,
  generalGoldLightModeBarbie: generalGoldLightModeBarbie,
  generalGoldLightModeGold: generalGoldLightModeGold$1,
  generalGrassDarkModeGrass: generalGrassDarkModeGrass,
  generalGrassLightModeGrass: generalGrassLightModeGrass$1,
  generalHotDarkModeHot: generalHotDarkModeHot$1,
  generalOceanLightModeOcean: generalOceanLightModeOcean$1
});

var _pages, _sites;
var generalGoldLightModeSky = generalGoldLightModeSky$1,
    generalOceanLightModeOcean = generalOceanLightModeOcean$1,
    generalBarbieLightModeBarbie = generalBarbieLightModeBarbie$1,
    generalGrassLightModeGrass = generalGrassLightModeGrass$1,
    generalGoldLightModeGold = generalGoldLightModeGold$1,
    generalGoldDarkModeGold = generalGoldDarkModeGold$1,
    generalHotDarkModeHot = generalHotDarkModeHot$1;
var themeMap = {
  pages: (_pages = {}, _defineProperty$1(_pages, SLOTS_UK_PAGE_IN_GAMBLING_PAGE_ID, generalGoldDarkModeGold), _defineProperty$1(_pages, PGR_PPC_PAGE_ID, generalGrassLightModeGrass), _defineProperty$1(_pages, CASINO_SE_SPORT_BETTING_INNER_CHART_PAGE_ID, generalGrassLightModeGrass), _defineProperty$1(_pages, CASINO_RO_MID_CHART_IN_SPORT_RO_PAGE_ID, generalGoldLightModeGold), _defineProperty$1(_pages, SLOTS_UK_MID_CHART_IN_BINGO_PAGE_ID, generalGoldLightModeGold), _defineProperty$1(_pages, CASINO_CHART_CROSS_IN_BINGO_PAGE_ID, generalGoldLightModeGold), _defineProperty$1(_pages, MID_CHART_CASINO_IN_SPORT_PAGE_ID, generalGoldLightModeGold), _defineProperty$1(_pages, CASINO_CHART_CROSS_IN_SPORT_PAGE_ID, generalGoldLightModeGold), _defineProperty$1(_pages, CASINO_RO_CROSS_IN_SPORT_RO_PAGE_ID, generalGoldLightModeGold), _defineProperty$1(_pages, SPORT_ONLINE_CASINO_PAGE_ID, generalGoldLightModeSky), _defineProperty$1(_pages, LIVE_CASINO_CHART_PAGE_IN_CASINO_PAGE_ID, generalGoldDarkModeGold), _defineProperty$1(_pages, BLACKJACK_CHART_CROSS_IN_CASINO_PAGE_ID, generalGoldDarkModeGold), _defineProperty$1(_pages, SPORT_AU_PRODUCT_POPUP_PAGE_ID, generalGrassLightModeGrass), _pages),
  sites: (_sites = {}, _defineProperty$1(_sites, BINGO_UK_SITE_ID, generalBarbieLightModeBarbie), _defineProperty$1(_sites, SPORT_UK_SITE_ID, generalGrassLightModeGrass), _defineProperty$1(_sites, SPORT_RO_SITE_ID, generalGrassLightModeGrass), _defineProperty$1(_sites, SPORT_FR_SITE_ID, generalOceanLightModeOcean), _defineProperty$1(_sites, CASINO_UK_SITE_ID, generalGoldLightModeSky), _defineProperty$1(_sites, SLOTS_UK_SITE_ID, generalGoldDarkModeGold), _defineProperty$1(_sites, ROULETTE_UK_SITE_ID, generalGoldDarkModeGold), _defineProperty$1(_sites, BLACKJACK_UK_SITE_ID, generalGoldDarkModeGold), _defineProperty$1(_sites, CASINO_RO_SITE_ID, generalGoldDarkModeGold), _defineProperty$1(_sites, GAMBLING_UK_SITE_ID, generalGoldLightModeSky), _defineProperty$1(_sites, RUMMY_IN_SITE_ID, generalHotDarkModeHot), _defineProperty$1(_sites, POKER_UK_SITE_ID, generalHotDarkModeHot), _defineProperty$1(_sites, SLOTS_RO_SITE_ID, generalGoldDarkModeGold), _defineProperty$1(_sites, CASINO_NL_SITE_ID, generalGoldLightModeSky), _defineProperty$1(_sites, CASINO_SE_SITE_ID, generalGoldLightModeSky), _defineProperty$1(_sites, SPORT_AU_SITE_ID, generalGrassLightModeGrass), _defineProperty$1(_sites, "default", generalGoldDarkModeGold), _sites)
};

var fetchThemeByContext = function fetchThemeByContext(_ref) {
  var _page$pageData;

  var common = _ref.common,
      page = _ref.page;
  var pageId = (page === null || page === void 0 ? void 0 : (_page$pageData = page.pageData) === null || _page$pageData === void 0 ? void 0 : _page$pageData.id) || '';

  if (pageId && themeMap.pages[pageId]) {
    return themeMap.pages[pageId];
  }

  var _common$siteId = common.siteId,
      siteId = _common$siteId === void 0 ? 0 : _common$siteId;

  if (siteId && themeMap.sites[siteId]) {
    return themeMap.sites[siteId];
  }

  return themeMap.sites["default"];
};
var getThemeByPriority = function getThemeByPriority(_ref2) {
  var themeByAE = _ref2.themeByAE,
      common = _ref2.common,
      page = _ref2.page;

  if (themeByAE) {
    var themeName = normalizeThemeName(themeByAE);
    return namedThemes[themeName] || generalGoldDarkModeGold$1;
  }

  return fetchThemeByContext({
    common: common,
    page: page
  });
};
var isMainChartIsLight = function isMainChartIsLight(siteId) {
  var _themeMap$sites$siteI, _theme$mobile;

  var theme = (_themeMap$sites$siteI = themeMap.sites[siteId]) !== null && _themeMap$sites$siteI !== void 0 ? _themeMap$sites$siteI : themeMap.sites["default"];
  return !((_theme$mobile = theme.mobile) !== null && _theme$mobile !== void 0 && _theme$mobile.isDark);
};
var calculateThemeByPriority = function calculateThemeByPriority(data) {
  var _page$themeSelection;

  // In xSite ui we get AE from page object, while in ni-comps-react we get from root query.
  var common = data.common,
      page = data.page;
  var themeByAE = page === null || page === void 0 ? void 0 : (_page$themeSelection = page.themeSelection) === null || _page$themeSelection === void 0 ? void 0 : _page$themeSelection.theme;
  return getThemeByPriority({
    themeByAE: themeByAE,
    common: common,
    page: page
  });
};

var normalizeThemeName = function normalizeThemeName(themeByAE) {
  return themeByAE.split('-').map(function (section, index) {
    return index === 0 ? section : section[0].toUpperCase() + section.slice(1);
  }).join('');
};

var ThemeToWindowScript = function ThemeToWindowScript() {
  var theme = useTheme();
  var formattedTheme = JSON.stringify(theme);
  return /*#__PURE__*/React.createElement("script", {
    id: "theme-placeholder",
    dangerouslySetInnerHTML: {
      __html: "const formattedTheme='".concat(formattedTheme, "';\n        const theme = JSON.parse(formattedTheme);\n        window.theme = theme;")
    }
  });
};

function timeOutPromise(func, timeInMs) {
  return new Promise(function (resolve) {
    return setTimeout(resolve, timeInMs);
  }).then(function () {
    return func();
  });
}

export { ThemeToWindowScript, calculateThemeByPriority, index$1 as desktopThemes, fetchThemeByContext, getThemeByPriority, isMainChartIsLight, index as mobileThemes, namedThemes, themeMap, timeOutPromise };
